import axios from "axios"
import { IsAuthorized } from "src/authentication/IsAuthorized"
import { getJWT } from "src/helper/localStore/getJWT"
import qs from 'qs';

class ReportingServices {
  async buildOnDemandReport(params: any, body:any): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reporting/on-demand/export/`,body,
        {
          headers: {
            'authentication-token': getJWT()!,
            Accept: "application/json"
          },
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: 'comma' });
          }
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async buildPreconfiguredReport(body:any): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reporting/preconfigured`,body,
        {
          headers: {
            'authentication-token': getJWT()!
          }
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getUrlReports(params:any): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reporting_url/`,
        {
          headers: {
            'authentication-token': getJWT()!
          },
          params
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
    
  }
  async getReports(): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reporting/preconfigured`,
        {
          headers: {
            'authentication-token': getJWT()!
          }
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getReportById(id:Number): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reporting/preconfigured/${id}`,
        {
          headers: {
            'authentication-token': getJWT()!
          }
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editReport(id:Number, body:any): Promise<any[]> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/reporting/preconfigured/${id}`,
        body,
        {
          headers: {
            'authentication-token': getJWT()!
          }
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteReport(id:Number): Promise<any[]> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/reporting/preconfigured/${id}`,
        {
          headers: {
            'authentication-token': getJWT()!
          }
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTypes(): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reporting/types/`,
        {
          headers: {
            'authentication-token': getJWT()!
          }
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const reportingServices = new ReportingServices()